/**
 * AUTO-GENERATED by scripts/prebuild-seo.js — do not edit manually.
 * When no site has been configured at build time the defaults below are used,
 * which effectively disables server-side client-site rendering.
 */
import { SiteConfig } from './site-config.token';

export const GENERATED_SITE_CONFIG: SiteConfig = {
    agencyID: 23,
    siteID: 96,
    siteGUID: '287086d5-28d7-4ffd-a3b3-cc7ba5dd7286',
    isClient: true,
    site: {
    "language": "en",
    "mode": 1,
    "type": 0,
    "profileID": 38,
    "currencyID": 43,
    "currency": {
        "agencyID": 23,
        "name": "South African Rand",
        "description": null,
        "code": "ZAR",
        "rate": 1,
        "isOnSite": true,
        "id": 43,
        "isActive": true,
        "createdOn": "2023-03-11T00:00:00",
        "isDeleted": false,
        "guid": "8b1bbed3-74c9-4c85-90ec-ca7c45fd0686",
        "_links": []
    },
    "code": "XLIT",
    "name": "XL International Travels",
    "slogan": null,
    "metaDescription": null,
    "metaKeywords": null,
    "senderName": null,
    "agencyID": 23,
    "emailProviderID": "a432ef6c-7479-47f9-952a-b48716ab5b20",
    "itinerarySiteIDs": null,
    "contentSiteID": 11,
    "bundleSiteID": 11,
    "trackingID": null,
    "tagID": null,
    "pixelID": null,
    "logoUrl": "https://platform.travelfind.me/uploads/site/logo/xl-international-travels-logo.png",
    "logoUrl2": "https://platform.travelfind.me/uploads/site/logo/xl-international-travels-logo.png",
    "favIconUrl": null,
    "address": null,
    "emailAddress": "marold@int-travels.co.za",
    "website": "www.int-travels.co.za",
    "telephone": "0114478300",
    "infantAgeFrom": null,
    "infantAgeTo": null,
    "childAgeFrom": null,
    "childAgeTo": null,
    "adultAgeFrom": null,
    "adultAgeTo": null,
    "socialUrlFacebook": "https://www.facebook.com/XLInternationaltravels/",
    "socialUrlInstagram": null,
    "socialUrlTwitter": null,
    "socialUrlPinterest": null,
    "socialUrlLinkedIn": null,
    "socialUrlTikTok": null,
    "socialUrlYouTube": null,
    "colorPrimary": null,
    "colorSecondary": null,
    "colorPrimary1": null,
    "colorSecondary1": null,
    "colorPrimary2": null,
    "colorSecondary2": null,
    "colorPrimary3": null,
    "colorSecondary3": null,
    "tradingAs": null,
    "registrationNumber": "1948/031813/07",
    "vatNumber": "4930108982",
    "bankAccountName": "Account: International Travels (PTY) Ltd",
    "bankAccountType": "Standard Bank",
    "bankAccountNumber": "000138061",
    "bankAccountBranchCode": "205",
    "bankAccountSwiftCode": null,
    "canPayOnline": false,
    "searchDelta": 50,
    "logoType": null,
    "roundPricesTo": 0,
    "id": 96,
    "isActive": true,
    "createdOn": "2023-04-19T11:38:30.1967185",
    "isDeleted": false,
    "guid": "287086d5-28d7-4ffd-a3b3-cc7ba5dd7286",
    "_links": [
        {
            "rel": "self",
            "method": "get",
            "href": "https://api.travelfind.me/v1/agencies/23/sites/287086d5-28d7-4ffd-a3b3-cc7ba5dd7286"
        },
        {
            "rel": "edit",
            "method": "put",
            "href": "https://api.travelfind.me/v1/agencies/23/sites/287086d5-28d7-4ffd-a3b3-cc7ba5dd7286"
        },
        {
            "rel": "delete",
            "method": "delete",
            "href": "https://api.travelfind.me/v1/agencies/23/sites/287086d5-28d7-4ffd-a3b3-cc7ba5dd7286"
        },
        {
            "rel": "searches",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/searches"
        },
        {
            "rel": "searches-no-content",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/searches/no-content"
        },
        {
            "templated": true,
            "name": "search",
            "method": "get",
            "rel": "curies",
            "href": "https://api.travelfind.me/v1/sites/96/searches/{guid}"
        },
        {
            "rel": "site-search-providers",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/search-providers"
        },
        {
            "rel": "site-layouts",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/layouts"
        },
        {
            "rel": "site-images",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/images"
        },
        {
            "rel": "trips",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/trips"
        },
        {
            "templated": true,
            "name": "trip-get",
            "method": "get",
            "rel": "curies",
            "href": "https://api.travelfind.me/v1/sites/96/trips/{guid}"
        },
        {
            "rel": "trip-add",
            "method": "post",
            "href": "https://api.travelfind.me/v1/sites/96/trips"
        },
        {
            "rel": "itineraries",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/itineraries"
        },
        {
            "rel": "packages",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/itineraries/packages"
        },
        {
            "templated": true,
            "name": "itinerary",
            "method": "get",
            "rel": "curies",
            "href": "https://api.travelfind.me/v1/sites/96/itineraries/{guid}"
        },
        {
            "rel": "itinerary-create",
            "method": "post",
            "href": "https://api.travelfind.me/v1/sites/96/itineraries"
        },
        {
            "rel": "profiles",
            "method": "get",
            "href": "https://api.travelfind.me/v1/agencies/23/sites/96/profiles"
        },
        {
            "rel": "subscribers",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/subscribers"
        },
        {
            "rel": "suppliers",
            "method": "get",
            "href": "https://api.travelfind.me/v1/suppliers/sites/96"
        },
        {
            "rel": "services",
            "method": "get",
            "href": "https://api.travelfind.me/v1/suppliers/0/services/sites/96"
        },
        {
            "rel": "profile-forgot-password",
            "method": "post",
            "href": "https://api.travelfind.me/v1/agencies/23/sites/96/accounts/profiles/forgot-password"
        },
        {
            "rel": "profile-reset-password",
            "method": "post",
            "href": "https://api.travelfind.me/v1/agencies/23/sites/96/accounts/profiles/reset-password"
        },
        {
            "rel": "tools",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/tools"
        },
        {
            "rel": "bundle-add",
            "method": "post",
            "href": "https://api.travelfind.me/v1/sites/96/bundles"
        },
        {
            "rel": "bundles-filter",
            "method": "post",
            "href": "https://api.travelfind.me/v1/sites/96/bundles/filter"
        },
        {
            "rel": "bundle-searches",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/bundles/searches"
        },
        {
            "rel": "facts",
            "method": "get",
            "href": "https://api.travelfind.me/v1/site/96/facts"
        },
        {
            "rel": "ai",
            "method": "get",
            "href": "https://api.travelfind.me/v1/sites/96/ai/{text}"
        },
        {
            "templated": true,
            "name": "supplier-by-guid",
            "method": "get",
            "rel": "curies",
            "href": "https://api.travelfind.me/v1/suppliers/{guid}?siteId=96"
        },
        {
            "templated": true,
            "name": "supplier-by-id",
            "method": "get",
            "rel": "curies",
            "href": "https://api.travelfind.me/v1/suppliers/id/{id}?siteId=96"
        }
    ]
},
    defaultTheme: "theme-brand",
    defaultLayout: "centered",
    defaultThemeStylesheet: "theme-stylesheet-xlt",
};
